'use client'

import { useEffect } from 'react'

import { usePathname, useSearchParams } from 'next/navigation'

import { useAppDispatch, useAppSelector } from '@/hooks'
import { authActions } from '@/redux/reducers/auth/auth.reducer'
import ClientOnly from '@/components/shared/ClientOnly'

export interface ProvidersProps {
  children: React.ReactNode
}

// const pathAuth = [
//   {
//     key: '/sign-in',
//   },
//   {
//     key: '/sign-up',
//   },
//   {
//     key: '/invite-code',
//   },
//   {
//     key: '/private-key',
//   },
// ]

// SIGNIN: 'sign-in',
//     SIGNUP: 'sign-up',
//     INVITECODE: 'invite-code',
//     PRIVATEKEY: 'private-key',

export function AuthProviders({ children }: ProvidersProps) {
  const dispatch = useAppDispatch()
  // const router = useRouter()
  const pathName = usePathname() // Khai báo PathName để lấy đường dẫn trang đang đứng
  const searchParam = useSearchParams() // Khai báo SearchParam để lọc trang đang đứng

  const accessToken = useAppSelector((state) => state.root.auth.accessToken)

  // const isLogin = pathAuth?.find((item) => item.key == pathName) ? true : false

  useEffect(() => {
    if (!accessToken) {
      const redirect = `${pathName}?${searchParam.toString()}` // Lọc tham số redirect

      dispatch(authActions.setRedirectInvite(redirect))

      // router.push(PATHS.SIGNIN)
      return
    }
  }, [])

  return (
    <ClientOnly>
      <div>{children}</div>
    </ClientOnly>
  )
}
